export const decodeFileName = (fileName: string): string => {
  const repairMojibake = (value: string): string => {
    const mojibakePattern = /[\u00C0-\u00DF][\u0080-\u00BF]|Ã[¤¥¶Ä¥–]|Ã\x83|Â|Ã¤|Ã¶|Ã¥|Ã„|Ã–|Ã…/;
    if (!mojibakePattern.test(value)) return value;
    try {
      const bytes = Uint8Array.from(Array.from(value, ch => ch.charCodeAt(0) & 0xff));
      const fixed = new TextDecoder('utf-8').decode(bytes).normalize('NFC');
      if (fixed && fixed !== value && !fixed.includes('\uFFFD')) {
        return fixed;
      }
    } catch {}
    return value;
  };

  try {
    const decoded = decodeURIComponent(fileName.replace(/\+/g, ' '));
    return repairMojibake(decoded).normalize('NFC');
  } catch {
    return repairMojibake(fileName).normalize('NFC');
  }
};
